import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Dropdown, Popconfirm, Popover, Space, Tag } from 'antd';
import React, { useRef, useState } from 'react';
import { queryKeys } from '../../services/react-query/queryKeys';
import {
  MdDelete,
  MdModeEditOutline,
  MdNoteAlt,
  MdOutlinePayment,
  MdSubtitles,
} from 'react-icons/md';
import Heading from '../../components/common/Heading/Heading';
import DynamicTableAnt from '../../hooks/DynamicTableAnt';
import {
  CheckOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import StatusTag from '../../hooks/StatusHook';
import { useNavigate } from 'react-router-dom';
import {
  deletePurchaseInvoice,
  getPurchaseInvoice,
} from '../../network/purchaseInvoice';
import {
  cancelMaterialRequest,
  submitMaterialRequest,
} from '../../network/materialRequest';
import { BiShow } from 'react-icons/bi';
import { TiCancel } from 'react-icons/ti';
import { SiKnowledgebase } from 'react-icons/si';
import { GiFiles } from 'react-icons/gi';
import {
  ModalAppPayment,
  ModalAppPdfData,
} from '../../components/upeosoft/ModalApp/ModalApp';
import PropsSearchTable from '../../components/common/PropsSearchTable/PropsSearchTable';
import { TbDotsVertical } from 'react-icons/tb';
import { getStatementOfAccountPdf } from '../../network/statementOfAccount';
import UseDownloadPdf from '../../hooks/DownloadPdf';
import DashboardCards from '../Dashboard/DashboardCards';
import { PiDotsThreeVerticalBold } from 'react-icons/pi';

const PurchaseInvoice = ({ t }) => {
  const navigate = useNavigate();
  const client = useQueryClient();
  const { message } = App.useApp();
  const searchInput = useRef(null);
  const searchInputMobile = useRef(null);
  const [textValue, setTextValue] = useState('');
  const [nameInvoice, setNameInvoice] = useState('');
  const [openPdf, setOpenPdf] = useState(false);
  const [searchText, setSearchText] = useState({
    value: '',
    key: '',
  });
  // const { mutate: onGetPDF, data: pdfData } = useMutation({
  //   mutationKey: ['getPDF'],
  //   mutationFn: (name) => getStatementOfAccountPdf(name),
  //   onSuccess: (data) => {
  //     console.log(data, 'data');
  //     if (data?.message?.status === 500) {
  //       message.error(data?.message?.message);
  //       return false;
  //     }
  //   },
  // });
  const { onGetPDF, pdfData,setLoadingPdf, loadingPdf } = UseDownloadPdf();
  const handleSearch = (selectedKeys, confirm, key) => {
    confirm();
    // console.log(`Searching for: ${selectedKeys[0]}, key: ${key}`);
    setSearchText({ value: selectedKeys[0], key });
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    setSearchText({ value: '', key: '' });
  };

  const props = ({ key, name }) =>
    PropsSearchTable({
      key: key,
      name: name,
      setTextValue: setTextValue,
      textValue: textValue,
      setSearchText: setSearchText,
      searchInputMobile: searchInputMobile,
      searchInput: searchInput,
      handleSearch: handleSearch,
      handleReset: handleReset,
      t: t,
    });
  const handleRemove = useMutation({
    mutationFn: (id) => deletePurchaseInvoice(id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message ? data?.message : 'Deleted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getPurchaseInvoice] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleCancle = useMutation({
    mutationFn: (id) => cancelMaterialRequest('Purchase Invoice', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500 || !data) {
        message.error(data?.message?.message || 'Error occured');
        return false;
      }
      message.success(data?.message?.message || 'Cancled successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getPurchaseInvoice] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const handleSubmit = useMutation({
    mutationFn: (id) => submitMaterialRequest('Purchase Invoice', id),
    onSuccess: (data) => {
      console.log(data, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(data?.message?.message || 'Submitted successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getPurchaseInvoice] });
    },
    onError: () => {
      message.error('Something went wrong');
    },
  });
  const { data, isLoading } = useQuery({
    queryKey: [queryKeys.getPurchaseInvoice, searchText.key, searchText.value],
    queryFn: () =>
      getPurchaseInvoice({
        key: searchText.key,
        value: searchText.value,
      }),
    keepPreviousData: true,
  });
  const items = (record) => [
    {
      key: '1',
      label: record?.status === 'Draft' ? t.edit : t.view,
      icon: record?.status === 'Draft' ? <MdModeEditOutline /> : <BiShow />,
      onClick: () => {
        if (record?.status === 'Draft') {
          navigate(`/purchase-invoice/edit/${record?.name}`);
        } else {
          navigate(`/purchase-invoice/view/${record?.name}`);
        }
      },
    },
    {
      key: '1-1',
      label: t.StockLedger,
      icon: <SiKnowledgebase />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => navigate(`/stock-ledger-report-invoice/${record?.name}`),
    },
    {
      key: '1-2',
      label: t.GeneralLedger,
      icon: <GiFiles />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => navigate(`/general-ledger-report-invoice/${record?.name}`),
    },
    {
      key: '6-1',
      label: t.getPDF,
      icon: <CheckOutlined />,
      onClick: () => {
        // onGetPDF(record.name);
        onGetPDF({
          type: 'Purchase Invoice',
          // name: nameInvoice,
          name: record.name,
          lang: 'ar',
          format: '',
        });
        setOpenPdf(true);
        setNameInvoice(record?.name);
      },
    },
    {
      type: 'divider',
    },
    {
      key: '3',
      label: t.Payment,
      icon: <MdOutlinePayment />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => {
        navigate(`/payment-entry/purchase-invoice/${record?.name}`);
      },
    },
    {
      key: '1-3',
      label: t.debitNote,
      icon: <MdNoteAlt />,
      disabled:
        record?.status !== 'Draft'
          ? false
          : record?.status !== 'Return'
          ? false
          : record?.status !== 'Debit Note Issued'
          ? false
          : true,
      onClick: () =>
        navigate(`/purchase-invoice/add-debit-note/${record?.name}`),
    },
    {
      type: 'divider',
    },
    {
      key: '6',
      label: t.submit,
      icon: <CheckOutlined />,
      disabled: record?.status === 'Draft' ? false : true,
      onClick: () => handleSubmit.mutate(record?.name),
    },
    {
      key: '7',
      label: t.Cancel,
      icon: <CloseCircleOutlined />,
      disabled: record?.docstatus === 1 ? false : true,
      onClick: () => handleCancle.mutate(record?.name),
    },
    {
      type: 'divider',
    },
    {
      key: '8',
      label: (
        <Popconfirm
          title={t.Delete + ` (${record?.name})`}
          okText={t.yes}
          cancelText={t.no}
          onConfirm={() => handleRemove.mutate(record?.name)}
        >
          <span style={{ color: 'red' }}>{t.Delete}</span>
        </Popconfirm>
      ),
      icon: <DeleteOutlined style={{ color: 'red' }} />,
    },
  ];
  const columns = [
    {
      title: t.Name,
      dataIndex: 'name',
      key: 'name',
      ...props({ key: 'name', name: t.Name }),
      render: (text, record) => {
        return (
          <span
            style={{ cursor: 'pointer' }}
            className="text-primary"
            onClick={() => {
              navigate(`/purchase-invoice/edit/${record.name}`);
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: t.supplierName,
      dataIndex: 'supplier_name',
      key: 'supplier_name',
      ...props({ key: 'supplier_name', name: t.supplierName }),
    },
    {
      title: t.Total,
      dataIndex: 'grand_total',
      key: 'grand_total',
    },
    {
      title: t.OutstandingAmount,
      dataIndex: 'outstanding_amount',
    },
    {
      title: t.status,
      dataIndex: 'status',
      key: 'status',
      render: (text, record) => <StatusTag status={record?.status} />,
      ...props({ key: 'status', name: t.status }),
    },
    {
      title: t.action,
      dataIndex: 'action',
      key: 'action',
      width: 100,
      render: (text, record) => {
        return (
          <Space>
            <Dropdown
              menu={{ items: items(record) }}
              trigger={['click']}
              overlayClassName="custom-dropdown"
              // placement="bottomCenter"
            >
              <Button
                size="small"
                type="text"
                icon={<PiDotsThreeVerticalBold size={20} color="#86888C" />}
              />
            </Dropdown>
            {/* {record?.status === 'Draft' && (
              <Button
                size="small"
                type="primary"
                onClick={() => {
                  navigate(`/purchase-invoice/edit/${record?.name}`);
                }}
                icon={<MdModeEditOutline />}
              />
            )}
            {record?.status !== 'Draft' && (
              <Button
                size="small"
                type="primary"
                onClick={() => {
                  navigate(`/purchase-invoice/view/${record?.name}`);
                }}
                icon={<BiShow />}
              />
            )}
            {record?.status === 'Draft' && (
              <Popover
                placement="top"
                title={t.submit}
                onClick={() => {
                  handleSubmit.mutate(record?.name);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  style={{ backgroundColor: '#28a745' }}
                  icon={<MdSubtitles />}
                />
              </Popover>
            )}
            {record?.docstatus === 1 && (
              <Popover
                placement="top"
                title={t.Cancel}
                onClick={() => {
                  handleCancle.mutate(record?.name);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  style={{ backgroundColor: '#ff4d4f' }}
                  icon={<TiCancel />}
                />
              </Popover>
            )}
            {record?.status !== 'Draft' &&
              record?.status !== 'Return' &&
              record?.status !== 'Debit Note Issued' && (
                <Popover
                  placement="top"
                  title={t.debitNote}
                  onClick={() => {
                    // handleDebitNote.mutate(record?.name);
                    navigate(
                      `/purchase-invoice/add-debit-note/${record?.name}`
                    );
                  }}
                >
                  <Button
                    size="small"
                    type="primary"
                    style={{ backgroundColor: '#288ba7' }}
                    icon={<MdNoteAlt />}
                  />
                </Popover>
              )}
            {record?.docstatus === 1 && (
              <Popover
                placement="top"
                title={t.StockLedger}
                onClick={() => {
                  navigate(`/stock-ledger-report-invoice/${record?.name}`);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  icon={<SiKnowledgebase />}
                  style={{
                    backgroundColor: '#c12f6e',
                  }}
                />
              </Popover>
            )}
            {record?.docstatus === 1 && (
              <Popover
                placement="top"
                title={t.Payment}
                onClick={() => {
                  navigate(`/payment-entry/purchase-invoice/${record?.name}`);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  icon={<MdOutlinePayment />}
                />
              </Popover>
            )}
            {record?.docstatus === 1 && (
              <Popover
                placement="top"
                title={t.GeneralLedger}
                onClick={() => {
                  navigate(`/general-ledger-report-invoice/${record?.name}`);
                }}
              >
                <Button
                  size="small"
                  type="primary"
                  icon={<GiFiles />}
                  style={{
                    backgroundColor: '#c12f6e',
                  }}
                />
              </Popover>
            )}
            {record?.docstatus !== 1 && (
              <Popconfirm
                title={t.DeletethePurchaseInvoice + ` (${record?.name})`}
                description={t.areYouSure}
                onConfirm={() => handleRemove.mutate(record?.name)}
                okText={t.yes}
                cancelText={t.no}
              >
                <Button
                  size="small"
                  type="primary"
                  danger
                  icon={<MdDelete />}
                />
              </Popconfirm>
            )} */}
          </Space>
        );
      },
    },
  ];
  const dataTable = data?.data?.map((item, index) => {
    return {
      key: index,
      ...item,
    };
  });
  return (
    <div className="inventory">
      {/* <Heading title={t.Inventory} subTitle={t.purchaseInvoice} path="/" /> */}
      <DashboardCards t={t} />
      <div className="mt-5">
        <DynamicTableAnt
          columns={columns}
          data={dataTable}
          loading={isLoading}
          setSearchText={setTextValue}
          Placeholder={t.searchByName}
          buttonModal={
            <Button
              type="primary"
              onClick={() => {
                navigate('/purchase-invoice/add');
              }}
            >
              <PlusOutlined
                style={{
                  fontSize: '10px',
                }}
              />
              {t.AddPurchaseInvoice}
            </Button>
          }
        />
      </div>
      <ModalAppPdfData
        open={openPdf}
        pdfData={pdfData}
        setOpen={setOpenPdf}
        nameInvoice={nameInvoice}
        t={t}
        onGetPDF={onGetPDF}
        type="Purchase Invoice"
                setLoadingPdf={setLoadingPdf}
        loadingPdf={loadingPdf}
      />
    </div>
  );
};

export default PurchaseInvoice;
